// The platform seam (issue #217): is this page running inside the Khronos
// Android app (mobile/, a Capacitor shell that loads this same site), or in a
// browser? The web code paths stay as they are; native-only behaviour hangs
// off isNativeApp() and the plugins below.
//
// In a browser @capacitor/core reports platform "web" and the native plugins
// are never called, so nothing here changes the web app.
import { Capacitor, registerPlugin } from "@capacitor/core";

/** True inside the Android app shell. */
export function isNativeApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

/**
 * True in a browser on an Android phone or tablet, where the Android app
 * could be installed instead (help article "android-app").
 */
export function isAndroidBrowser() {
  if (isNativeApp()) return false;
  try {
    return /Android/i.test(navigator.userAgent || "");
  } catch {
    return false;
  }
}

/**
 * Native Google sign-in (mobile/android/.../KhronosAuthPlugin.java).
 * signInWithGoogle({ serverClientId }) → { idToken, email }; rejects with
 * code "CANCELLED" when the user backs out of the account picker.
 */
export const KhronosAuth = registerPlugin("KhronosAuth");

/**
 * The installed Android app's own version, from @capacitor/app's App plugin
 * (bundled in mobile/). Resolves { version, build } (versionName and
 * versionCode in mobile/android/app/build.gradle), or null in a browser or
 * when the shell can't say.
 */
const CapApp = registerPlugin("App");
export async function getNativeAppInfo() {
  if (!isNativeApp()) return null;
  try {
    const info = await CapApp.getInfo();
    return info && info.version
      ? { version: String(info.version), build: info.build ? String(info.build) : null }
      : null;
  } catch {
    return null;
  }
}
